import { useTipTapEditorContext } from "@circle-react-uikit/TipTap/TipTapEditorContext";
import { supportsGalleryPreview } from "@circle-react-uikit/TipTap/utilities/contentTypeParser";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { AttachmentItem } from "./AttachmentItem";
import type { Attachment } from "./types";

export interface AttachmentPreviewsCompassProps {
  attachmentsList: Attachment[];
}

export const AttachmentPreviewsCompass = ({
  attachmentsList,
}: AttachmentPreviewsCompassProps) => {
  const { editor } = useTipTapEditorContext();
  if (!attachmentsList.length) {
    return null;
  }

  const hasOnlyOneAttachment = attachmentsList.length === 1;

  const attachmentsForGalleryPreview = attachmentsList.filter(a =>
    supportsGalleryPreview(a.content_type),
  );

  return (
    <div
      className={classNames("flex items-center gap-2 pb-0.5", {
        "w-full flex-wrap": !editor.isEditable,
      })}
    >
      {attachmentsList.map((attachment, index) => (
        <AttachmentItem
          index={index}
          attachmentsForGalleryPreview={attachmentsForGalleryPreview}
          key={attachment.signed_id}
          attachment={attachment}
          shouldShowEnlarged={!editor.isEditable && hasOnlyOneAttachment}
        />
      ))}
    </div>
  );
};
